import * as net from 'util/Net';
import {ValidationRulesErrorResponse} from 'validation_rules/network/types';

export function validateUserInputFormula(
  hasValidationRulesItemId: string,
  userInputFormula: string
): Promise<ValidationRulesErrorResponse> {
  return net.postJSONPromise({
    url: `/1/api/validation-rules:validate-syntax`,
    data: {hasValidationRulesItemId, userInputFormula},
  });
}
